
























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConfigService } from '@/services/ConfigService';
import { ApiService } from '@/services/ApiService';
import { CustomersApi, EffectiveCustomerDto } from '@eurogast/hub-client-typescript';

@Component
export default class CustomerSelector extends Vue {
  @Prop({ required: true })
  public localHideReceiptLink: string;
  public visible = false;
  public customersApi = ApiService.wrap(CustomersApi);
  public customerCount = 0;
  public username = ConfigService.getDisplayName();
  private currentCustomer: EffectiveCustomerDto = null;

  public focusOut(event) {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      this.visible = false;
    }
  }

  get hideReceiptLink() {
    return this.localHideReceiptLink === 'true';
  }

  get currentCustomerId() {
    return ConfigService.currentCustomerId;
  }

  get customerName() {
    if (this.currentCustomer && this.currentCustomer.displayName && this.currentCustomer.displayName !== '') {
      return this.currentCustomer.displayName.split(',');
    }
    return null;
  }

  get customerStreet() {
    if (this.currentCustomer && this.currentCustomer.customerAddress && this.currentCustomer.customerAddress.street) {
      return this.currentCustomer.customerAddress.street;
    }
    return null;
  }

  get customerCity() {
    let city = '';
    if (this.currentCustomer && this.currentCustomer.customerAddress) {
      if (this.currentCustomer.customerAddress.postCode) {
        city += this.currentCustomer.customerAddress.postCode + ' ';
      }
      if (this.currentCustomer.customerAddress.city) {
        city += this.currentCustomer.customerAddress.city;
      }
      return city;
    }
    return null;
  }

  public mounted() {
    this.customersApi.getCustomersOfCurrentUser(ConfigService.getTenant()).then((customers: EffectiveCustomerDto[]) => {
      this.customerCount = customers.length;

      this.currentCustomer = customers.find((x) => x.customerId === this.currentCustomerId);
      if (this.customerCount === 0) {
        const errorMsg = this.$t('common.customerSelector.error.noActiveCustomers');
        ApiService.defaultInfoHandler(errorMsg.toString());
        return;
      }

      if (!this.currentCustomer) {
        this.currentCustomer = customers[0];
        ConfigService.currentCustomerId = this.currentCustomer.customerId;
      }

    }).catch(ApiService.defaultErrorHandler);
  }

  public scrollTop() {
    window.scrollTo(0, 0);
  }
}
